import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { getItemsAssignedToReportingCategory } from 'store/Items/selector'

const ReportingCategoryItem = ({ name, uuid }) => {
  const assignedItemsToReportingCategory = useSelector((state) =>
    getItemsAssignedToReportingCategory(state, uuid)
  )

  const onClickItem = () =>
    history.push(`reporting-categories/${uuid}`)

  const history = useHistory()
  return (
    <div className="item">
      <div className="row">
        <div className="item-info-wrapper" onClick={onClickItem}>
          {name}
        </div>
        <div className="item-info-wrapper">
          {assignedItemsToReportingCategory.length ?? 0}
        </div>
      </div>
    </div>
  )
}

ReportingCategoryItem.propTypes = {
  name: PropTypes.string,
  uuid: PropTypes.string,
}

export default ReportingCategoryItem
